const anchor = () => {
  // メガメニューの親リンクは、custom-header.jsで処理するため除外する。
  document.querySelectorAll('a[href^="#"]:not([data-mega-trigger])').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      const header = document.querySelector('header');
      const headerStyle = window.getComputedStyle(header);
      const headerPosition = headerStyle.position;
      const headerHeight = header.offsetHeight;

      const href = link.getAttribute('href');
      const target = (href === '#' || href === '')
        ? document.documentElement
        : document.querySelector(href);

      if (!target) return;

      let position = target.getBoundingClientRect().top + window.scrollY;

      if (headerPosition === 'fixed') {
        position -= headerHeight;
      }

      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    });
  });
};

anchor();
